module.exports = __webpack_public_path__ + "assets/img/27_1288_big.a53eaf06.jpg";